import { ACCESS_CODE_ADD } from "@client/actions";
import { Action } from "@client/lib/action";
import { EmailEditForm, ActionCodeInfo, RegisterEmailForm, AuthCredential, LoginForm, User, AuthCodeInfo, ForgotPasswordForm, ResetPasswordForm, UpdatePasswordForm, Session, FaqDataInfo, FaqInfo, OrganizationInfo, SectorInfo, ContractInfo, ParkInfo, ServiceInfoWithGroup, SubscriptionService, ContractForm, NodeItem, LayoutScreenInfo, ProfileInfo, ProfileWritableEntities, ProfileEditForm, SubscriptionInfo, UserEntity, AccessCodeInfo, MetadataState, AccountStatusState, AccessCodeSearchInfo, UserState, Vehicule, ServiceInfo, AccessCodeGroupInfo } from "@client/utils/shared-constants";

export class AccessCodeAddInitAction implements Action {
    readonly type = ACCESS_CODE_ADD.INIT;
    constructor(public payload?: null, public correlationId?: number) {
    }
}

export class AccessCodeAddDestroyAction implements Action {
    readonly type = ACCESS_CODE_ADD.DESTROY;
    constructor(public payload?: null, public correlationId?: number) {
    }
}

export class AccessCodeAddFormUpdateAction implements Action {
    readonly type = ACCESS_CODE_ADD.FORM_UPDATE;
    constructor(public payload: AccessCodeSearchInfo, public correlationId?: number) {
    }
}

export class AccessCodeAddSubmitAction implements Action {
    readonly type = ACCESS_CODE_ADD.SUBMIT;
    constructor(public payload: AccessCodeSearchInfo, public correlationId?: number) {
    }
}
